import { render, staticRenderFns } from "./SsoAuth.vue?vue&type=template&id=9fce78e6&scoped=true&"
import script from "./SsoAuth.vue?vue&type=script&lang=js&"
export * from "./SsoAuth.vue?vue&type=script&lang=js&"
import style0 from "./SsoAuth.vue?vue&type=style&index=0&id=9fce78e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fce78e6",
  null
  
)

export default component.exports